import { lazy } from "react"
import { lazyRetry } from "./utils"
import { AuthenticatedLayout } from "./wrappers"
import { Route } from "react-router-dom"

const Help = lazy(() => lazyRetry(() => import("../views/Help/Help"), "help"))
const HelpNavigationPanel = lazy(() => lazyRetry(() => import("../components/Navigation/HelpNavigationPanel"), "helpNavigationPanel"))

const HelpRoute = (
	<Route path="/help" element={<AuthenticatedLayout className="help-layout" rightPanel={<HelpNavigationPanel />} />}>
		<Route path="/help" element={<Help />} />
	</Route>
)

export default HelpRoute
